export class TreeView{
  tree: tree[];
}
export class tree{

  cat;
  cdv;
  child: tree[] = [];
  class;
  etat;
  id;
  idp;
  expandable: boolean;
  name: string;
  level: number;
}
